import React from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import MyVerticallyCenteredModal from '../EventModal';
import RespNav from '../RespNav';
import './navbarBtn.css'
const HeroNavbar = () => {
    const [modalShow, setModalShow] = React.useState(false);
    const [btn1Ac, setBtn1Ac] = React.useState('btn11H')
    const [btn2Ac, setBtn2Ac] = React.useState('btn11H')
    const [btn3Ac, setBtn3Ac] = React.useState('btn11H')
    const [btn4Ac, setBtn4Ac] = React.useState('btn11H')
    const [btn5Ac, setBtn5Ac] = React.useState('btn11H')
    const [btn6Ac, setBtn6Ac] = React.useState('btn11H')
    const clickBtn1 = () => {
        setBtn1Ac('btn1H')
        setBtn2Ac('btn11H')
        setBtn3Ac('btn11H')
        setBtn4Ac('btn11H')
        setBtn5Ac('btn11H')
        setBtn6Ac('btn11H')
    }
    const clickBtn2 = () => {
        setBtn1Ac('btn11H')
        setBtn2Ac('btn1H')
        setBtn3Ac('btn11H')
        setBtn4Ac('btn11H')
        setBtn5Ac('btn11H')
        setBtn6Ac('btn11H')
    }
    const clickBtn3 = () => {
        setBtn1Ac('btn11H')
        setBtn2Ac('btn11H')
        setBtn3Ac('btn1H')
        setBtn4Ac('btn11H')
        setBtn5Ac('btn11H')
        setBtn6Ac('btn11H')
    }
    const clickBtn4 = () => {
        setBtn1Ac('btn11H')
        setBtn2Ac('btn11H')
        setBtn3Ac('btn11H')
        setBtn4Ac('btn1H')
        setBtn5Ac('btn11H')
        setBtn6Ac('btn11H')
    }
    const clickBtn5 = () => {
        setBtn1Ac('btn11H')
        setBtn2Ac('btn11H')
        setBtn3Ac('btn11H')
        setBtn4Ac('btn11H')
        setBtn5Ac('btn1H')
        setBtn6Ac('btn11H')
    }
    const clickBtn6 = () => {
        setBtn1Ac('btn11H')
        setBtn2Ac('btn11H')
        setBtn3Ac('btn11H')
        setBtn4Ac('btn11H')
        setBtn5Ac('btn11H')
        setBtn6Ac('btn1H')
    }
    return (
        <>
            <Navbar expand='lg' variant='dark' className='bg-transparent w-100 pe-3' style={{ position: 'absolute', zIndex: 1 }}>
                <Navbar.Brand href='#' className='ms-md-3'>
                    <img
                        src='/img/Vaultus-removebg-preview 1.png'
                        className='w-100 ps-3 ps-md-5'
                        alt=''
                    />
                </Navbar.Brand>
                <RespNav />
                <Navbar.Collapse id='basic-navbar-nav' className='d-none d-md-block'>
                    <Nav className='ms-auto fs-6 px-5 d-flex justify-content-center align-items-center'>
                        <Nav.Link className={btn1Ac} onClick={clickBtn1} style={{ fontFamily: "Poppins", fontWeight: "500", fontSize: "16px" }} href='#theClub '>The Club </Nav.Link>
                        <Nav.Link className={btn2Ac} onClick={clickBtn2} style={{ fontFamily: "Poppins", fontWeight: "500", fontSize: "16px" }} href='#mining'>Mining</Nav.Link>
                        <Nav.Link className={btn3Ac} onClick={clickBtn3} style={{ fontFamily: "Poppins", fontWeight: "500", fontSize: "16px" }} href='#green'>Green Bitcoin</Nav.Link>
                        <Nav.Link className={btn4Ac} onClick={clickBtn4} style={{ fontFamily: "Poppins", fontWeight: "500", fontSize: "16px" }} href='#'>Benefits</Nav.Link>
                        <Nav.Link className={btn5Ac} onClick={clickBtn5} style={{ fontFamily: "Poppins", fontWeight: "500", fontSize: "16px" }} href='#white-papers'>White Papers</Nav.Link>
                        <Nav.Link className={btn6Ac} onClick={clickBtn6} style={{ fontFamily: "Poppins", fontWeight: "500", fontSize: "16px" }} href='#timeline'>Timeline</Nav.Link>
                        <Nav.Link onClick={() => setModalShow(true)}>
                            <div className='ms-4'>
                                <button className='navBtn'>Membership</button>
                            </div>
                        </Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
            <MyVerticallyCenteredModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />
        </>
    );
};

export default HeroNavbar;